import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";

export default class GeneralLedgerSettings extends BaseProductSettings {
    enabled: boolean;
    transactionSourceGLId: string = '';
    savingsPortfolioControlGLId: string = '';
    savingsInterestExpenseGLId: string = '';
    savingsInterestPayableGLId: string = '';
    savingsFeeIncomeGLId: string = '';
    state: string = 'ACTIVE';
}